import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    // Initialize fbq function
    // @ts-ignore
    window.fbq = function () {
      // @ts-ignore
      window.fbq.callMethod ?
      // @ts-ignore
      window.fbq.callMethod.apply(window.fbq, arguments) :
      // @ts-ignore
      window.fbq.queue.push(arguments);
    };
    // @ts-ignore
    if (!window._fbq) window._fbq = window.fbq;
    // @ts-ignore
    window.fbq.push = window.fbq;
    // @ts-ignore
    window.fbq.loaded = true;
    // @ts-ignore
    window.fbq.version = '2.0';
    // @ts-ignore
    window.fbq.queue = [];
    // Create and inject the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Append to head (safer than relying on existing scripts)
    document.head.appendChild(script);
    // Initialize pixel after script element is created
    script.onload = () => {
      // @ts-ignore
      if (window.fbq) {
        // @ts-ignore
        window.fbq('init', '1284239833523300');
        // @ts-ignore
        window.fbq('track', 'PageView');
      }
    };
    // Fallback: initialize immediately in case script loads synchronously
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('init', '1284239833523300');
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-42">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1284239833523300&ev=PageView&noscript=1" alt="" data-id="element-43" />
    </noscript>;
}